import { useMemo } from 'react';
import {
  ButtonVariants,
  Modal,
  ModalSizes,
  Typography,
  TypographyColors,
  TypographyVariants,
} from '@carboledger/ui';
import { useTranslations } from '@/hooks';

/**
 * Props:
 *   open     whether the modal is shown
 *   onClose  close handler (✕ / OK)
 */
export const ImportUnavailableModal = ({ open, onClose }) => {
  const t = useTranslations();

  const buttons = useMemo(
    () => [{ label: t('COMMON_CLOSE'), variant: ButtonVariants.primary, onClick: onClose }],
    [t, onClose],
  );

  return (
    <Modal
      open={open}
      size={ModalSizes.small}
      title={t('CUSTOMERS_IMPORT_UNAVAILABLE_TITLE')}
      onClose={onClose}
      buttons={buttons}
    >
      <Typography variant={TypographyVariants.bodySm} color={TypographyColors.secondary}>
        {t('CUSTOMERS_IMPORT_UNAVAILABLE_DESCRIPTION')}
      </Typography>
    </Modal>
  );
};
